import { supportedLanguagesByLocaleCode } from './locales'
import { LiveLanguageCodes } from './types'

type LocaleConfig = {
  isProduction: boolean
  localeCookieDomain: string
  enabledLocales?: Record<LiveLanguageCodes, boolean>
}

let config: LocaleConfig = {
  isProduction: false,
  localeCookieDomain: '',
}

const originalEnabledByDefault: Record<string, boolean> = Object.fromEntries(
  Object.values(supportedLanguagesByLocaleCode).map((locale) => [
    locale.localeCode,
    locale.enabledByDefault,
  ]),
)

export function configureLocales(options: LocaleConfig): void {
  config = { ...config, ...options }

  if (options.enabledLocales) {
    for (const locale of Object.values(supportedLanguagesByLocaleCode)) {
      ;(locale as { enabledByDefault: boolean }).enabledByDefault =
        options.enabledLocales[locale.localeCode]
    }
  }
}

export function isProductionEnvironment(): boolean {
  return config.isProduction
}

export function getLocaleCookieDomain(): string {
  return config.localeCookieDomain
}

export const isSupportedLanguage = (
  language: string | undefined,
): language is LiveLanguageCodes => {
  if (language && language in supportedLanguagesByLocaleCode) {
    const locale = supportedLanguagesByLocaleCode[language as LiveLanguageCodes]
    if (isProductionEnvironment() && !locale.enabledByDefault) {
      return false
    }
    return true
  }

  return false
}

export function resetLocales(): void {
  config = { isProduction: false, localeCookieDomain: '' }
  for (const locale of Object.values(supportedLanguagesByLocaleCode)) {
    ;(locale as { enabledByDefault: boolean }).enabledByDefault =
      originalEnabledByDefault[locale.localeCode]!
  }
}

export const shouldShowOverrideDialogue = (): boolean => {
  const OVERRIDE_QUERY_KEY = '__monzo_locale_override__'
  if (typeof window === 'undefined') {
    return false
  }
  const query = new URLSearchParams(window.location.search)
  return query.has(OVERRIDE_QUERY_KEY)
}
